import CardSymphony from 'elements/CardSymphony';
import { clsx, styx } from 'modules/Utils';
import { CSSProperties, useState } from 'react';
import WebsiteBuilderHeader from '../WebsiteBuilderHeader';
import useWebsiteBuilder, { WebsiteBuilder_textExists } from 'Hooks/useWebsiteBuilder';
import InputSymphony from 'elements/InputSymphony';
import SwitchSymphony from 'elements/SwitchSymphony';
import WebsiteBuilderFooter from '../WebsiteBuilderFooter';

interface TextContentProps {
    className: string;
    contentIndex: number;
    tabSelectorComponent: React.ReactNode;
    id: string;
}

const TextContent = ({
    className,
    contentIndex,
    tabSelectorComponent,
    id,
}: TextContentProps) => {
    const {
        websiteContent,
        setWebsiteContent,
    } = useWebsiteBuilder() as WebsiteBuilder_textExists;

    const textContent = websiteContent[contentIndex].textContent;

    // NOTE: render()
    return (
        <CardSymphony
            className={clsx("textContentComponent", className)}
            style={styx(sty.textContentComponent)}
            size="small"
            id={id}
        >
            <WebsiteBuilderHeader
                contentIndex={contentIndex}
                rightSideContent={
                    tabSelectorComponent
                }
            />
            <InputSymphony
                className="textContentTitleInput"
                value={textContent.title || ''}
                onChange={(value) => {
                    const updatedContent = [...websiteContent];
                    updatedContent[contentIndex].textContent.title = value || '';
                    setWebsiteContent(updatedContent);
                }}
                placeholder="Title"
                label="Title"
            />
            <SwitchSymphony
                className="textContentSubtitleSwitch"
                checked={textContent.isSubtitle}
                onChange={(value) => {
                    const updatedContent = [...websiteContent];
                    updatedContent[contentIndex].textContent.isSubtitle = value;
                    setWebsiteContent(updatedContent);
                }}
                label="Subtitle"
            />
            {textContent.isSubtitle &&
                <InputSymphony
                    className="textContentSubtitleInput"
                    value={textContent.subtitle || ''}
                    onChange={(value) => {
                        const updatedContent = [...websiteContent];
                        updatedContent[contentIndex].textContent.subtitle = value || '';
                        setWebsiteContent(updatedContent);
                    }}
                    placeholder="Subtitle"
                    label="Subtitle"
                />
            }
            <WebsiteBuilderFooter
                className="textContentFooter"
                contentIndex={contentIndex}
                isBackgroundColor
                isTextColor
            />
        </CardSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    textContentComponent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    }
}

export default TextContent;